import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'; /*--------------JIT------------------*/
// import { platformBrowser }    from '@angular/platform-browser'; /*--------------AOT------------------*/
// 
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// 
if (environment.production) {
  enableProdMode();
}
platformBrowserDynamic().bootstrapModule(AppModule);  /*--------------JIT------------------*/
// platformBrowser().bootstrapModule(AppModule); /*--------------AOT------------------*/



/*--------------AOT------------------*/
// import { platformBrowser }    from '@angular/platform-browser';
// import { AppModuleNgFactory } from '../aot/src/app/app.module.ngfactory';

// console.log('Running AOT compiled');
// platformBrowser().bootstrapModuleFactory(AppModule);


// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/main.ts